import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { Translate } from '@dreryk/react-common';
import { IconSize, InfoRoundIcon, StrongText, StyledFlex, Tooltip } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../../translations';

import { ConfidentialDataAccessDescriptionLeadingText } from './ConfidentialDataAccessCellHeader.styled';

export const ConfidentialDataAccessCellHeader = (): ReactElement => {
   return (
      <StyledFlex gap={'4px'} alignItems={'center'}>
         <StrongText testId={'confidentialDataAccess'}>
            <Translate>{practitionersTranslationKeys.table.confidentialDataAccess}</Translate>
         </StrongText>
         <Tooltip
            testId={'confidentialDataAccessInfo'}
            content={
               <StyledFlex direction={'column'}>
                  <div>
                     <Trans
                        i18nKey={practitionersTranslationKeys.table.authorizedConfidentialDataAccessDescription}
                        components={{
                           strong: (
                              <ConfidentialDataAccessDescriptionLeadingText
                                 testId={'confidentialDataAccessAuthorized'}
                              />
                           ),
                        }}
                     />
                  </div>
                  <div>
                     <Trans
                        i18nKey={practitionersTranslationKeys.table.monitoredConfidentialDataAccessDescription}
                        components={{
                           strong: (
                              <ConfidentialDataAccessDescriptionLeadingText
                                 testId={'confidentialDataAccessMonitored'}
                              />
                           ),
                        }}
                     />
                  </div>
               </StyledFlex>
            }
         >
            <InfoRoundIcon testId={'confidentialDataAccessInfo'} size={IconSize.SMALL} />
         </Tooltip>
      </StyledFlex>
   );
};
